module.exports = __webpack_public_path__ + "static/media/EXERGUECHAP2.4fc22224.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/EXERGUECHAP2.png
// module id = 251
// module chunks = 0